import React, { useEffect } from "react";
import { Outlet } from "react-router-dom";
import Navbar from "../../components/Navbar";
import Footer from "../../components/Footer";
import { initAnonymousAuth } from "../../lib/firebase";
import { CurrencyProvider } from "../../lib/CurrencyContext";

export default function FoonLayout() {
  useEffect(() => {
    initAnonymousAuth();
  }, []);

  return (
    <CurrencyProvider>
      <div className="bg-white min-h-screen font-['Helvetica_Neue',sans-serif] max-w-[1440px] mx-auto overflow-x-hidden">
        <Navbar />

        <main className="overflow-x-clip">
          <Outlet />
        </main>

        <Footer />
      </div>
    </CurrencyProvider>
  );
}
